import qs from 'qs'
import { states } from '~/sow/details/constants'

export const userRoles = {
  Employer: 'employer',
  Vendor: 'vendor',
  All: 'ALL'
}

export function defaultSowParams(isVendor) {
  const stateList = [
    states.STATE_ACTIVE,
    states.STATE_AWAITING_CLIENT_REVIEW,
    states.STATE_AWAITING_VENDOR_REVIEW,
    states.STATE_DRAFT_CLIENT_COUNTERED,
    states.STATE_APPROVAL_PENDING
  ]

  if (!isVendor) {
    stateList.push(states.STATE_DRAFT_CLIENT)
  }

  return {
    search: '',
    state: stateList.join(',')
  }
}

export function getDefaultSowListURL(isVendor) {
  return `/sow/?${qs.stringify(defaultSowParams(isVendor))}`
}
